import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

const tableStyle = {
  backgroundColor: '#ffffff',
}

const divStyle = {
  paddingTop: '30px',
}

const linkStyle = {
  fontWeight: 'normal',
  color: 'black',
  paddingRight: '10px',
  border: 'none',
}

const aStyle = {
  display: 'none',
}

class AllVacationsComponent extends Component {
  constructor(props) {
    super(props)

    const options = []
    for (let i = 0; i < this.props.allUsers.length; i++) {
      const user = this.props.allUsers[i]
      options.push({value: user.id, label: user.fullName})
    }

    this.state = {
      userId: null,
      options: options,
    }
  }

  renderHeader() {
    return <Fragment><th key="person">Person</th><th key="period">Period</th><th key="type">Type</th><th key="accepted">Accepted?</th><th key="actions" colSpan="2">Actions</th></Fragment>
  }

  renderData() {
    let userFullName = ''
    for (let i = 0; i < this.props.allUsers.length; i++) {
      if (this.props.allUsers[i].id === this.state.userId) {
        userFullName = this.props.allUsers[i].fullName
        break
      }
    }

    const userVacations = this.props.allUsersVacations[this.state.userId]
    return userVacations.map(vacation => {
      return <tr key={vacation.id}><td>{userFullName}</td><td>{`${vacation.start} to ${vacation.end}`}</td><td>{vacation.type}</td><td>{vacation.accepted}</td><td><span><a href="#" onClick={() => this.handleSubmit(vacation['id'], this.props.currentUserId)} style={linkStyle}>Cancel vacation</a></span></td></tr>
    }
    )
  }

  handleSubmit(idV, idU) {
    const urlf = '/api/v1/destroy_vacation'
    confirmAlert({
      title: 'Confirm',
      message: 'Are you sure you want to cancel this time off?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            let body = ''
            body = JSON.stringify({id: idU, vacation_id: idV})
            fetch(urlf, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: body,
            })
            .then(response => response.json())
            .then((data) => {
              if (data.type === 'success'){
                document.getElementById('mylink').click()
              } else {
                console.error('err' + data.message)
              }
            })
            .catch((err) => {
              console.error('Error while cancelling time off! ' + err)
            })
          },
        },
        {
          label: 'No',
          onClick: () => {
            document.getElementById('react-confirm-alert').close
          },
        },
      ],
    })
  }

  render() {
    if (this.state.userId) {
      const ref = window.location.href
      return <Fragment><h4>Upcoming vacations of all users</h4><Select id="selectUser" options={this.state.options} placeholder="Select the user" onChange={e => this.setState({userId: e.value})}></Select><div className="row justify-content-center align-items-center" style={divStyle}><a href={ref} id="mylink" style={aStyle}></a><table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeader()}</tr>{this.renderData()}</tbody></table></div></Fragment>
    } else {
      return <Fragment><h4>Upcoming vacations of all users</h4><Select options={this.state.options} placeholder="Select the user" onChange={e => this.setState({userId: e.value})}></Select></Fragment>
    }
  }
}

AllVacationsComponent.propTypes = {
  allUsers: PropTypes.array.isRequired,
  allUsersVacations: PropTypes.object.isRequired,
  currentUserId: PropTypes.number.isRequired,
}

export default AllVacationsComponent
